import { DataBean } from "../DataBean";

export class ProductionOrderForClose extends DataBean {



    public async getProductionOrderCatalogForClose(idAccount: any, idProduct: any, code: any, year: any, month: any, idManufacturingStardard: any, idAttentionOffice: any, state: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getProductionOrderCatalogForClose_Number_Number_Number_Number_Number_Number_Number_Number_Number_Number", [idAccount, idProduct, code, year, month, idManufacturingStardard, idAttentionOffice, state, page, recordsPerPage]);
    }

}